module.exports = __webpack_public_path__ + "static/media/chickFlicks.ad1b7d07.jpg";